<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Crew Details &nbsp;
          <add-button link="crew-details/create"></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Rest Hour Management</li>
          <li class="breadcrumb-item">Crew Details</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Export To Excel -->
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <div style="float: right">
                  <a
                    href="#"
                    class="btn btn-primary"
                    v-if="Exportcrews.length == 0"
                    @click="exportToExcel"
                  >
                    <span v-if="isExcelloading">
                      <div class="d-flex align-items-center">
                        <strong>Generating Excel</strong>
                        &nbsp;
                        <div
                          class="
                            spinner-border
                            text-light
                            spinner-border-sm
                            ms-auto
                          "
                          role="status"
                          aria-hidden="true"
                        ></div>
                      </div>
                    </span>
                    <span v-else>Generate Excel</span>
                  </a>
                  <download-excel
                    :title="title"
                    v-else
                    class="btn btn-success"
                    :data="crews_excel"
                    :fields="excel_fields"
                    worksheet="Crew Details"
                    name="Crew Detail.xls"
                    >Download Excel
                  </download-excel>
                </div>
              </div>
            </div>
            <br />
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Full Name</th>
                    <th>Employee Role</th>
                    <th>Employee Code</th>
                    <th>location</th>
                    <th>Username</th>
                    <th>InActive</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="crews.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr v-for="(crew, at) in crews" :key="`crew${at}`">
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>{{ crew.full_name }}</td>
                    <td>
                      {{ crew.employee_role ? crew.employee_role.name : "" }}
                    </td>
                    <td>
                      {{ crew.employee_code }}
                    </td>
                    <td>
                      {{ crew.location ? crew.location.name : "" }}
                    </td>
                    <td></td>
                    <td>{{ crew.is_active == 1 ? "YES" : "NO" }}</td>
                    <td>
                      <div>
                        <router-link
                          :to="`crew-details/${crew.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(crew.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "crew",
  data() {
    return {
      crews: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      crews_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
        Address: "address",
        Country: "country",
        Email: "email",
        Phone: "phone",
        "Fax Number": "fax_no",
      },
      Exportcrews: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let crews = await axios.get(
        `/crews?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.crews = crews.data.data;
      this.count = crews.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let crews = await axios.get(`/crews?search=${this.searchData}`);
      this.crews = crews.data.data;
      this.count = crews.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Crew Detail Data";
      this.crews_excel = [];
      let Exportcrews = [];
      Exportcrews = await axios.get(`/crews`);
      this.Exportcrews = Exportcrews.data.data;
      let sr_no = 1;
      this.Exportcrews.forEach((crew) => {
        this.crews_excel.push({
          sr_no: sr_no,
          name: crew.name ? crew.name : "",
          address: crew.address ? crew.address : "",
          country: crew.country ? crew.country.name : "",
          email: crew.email ? crew.email : "",
          phone: crew.phone ? crew.phone : "",
          fax_no: crew.fax_no ? crew.fax_no : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=crews`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
